import React, { useContext } from "react";
import { Button, InputGroup } from "react-bootstrap";
import { StateContext } from "../../contexts/StateContext";
import _ from "lodash";

const CartItemCount = ({ item }) => {
  const { cart, setCart } = useContext(StateContext);

  const setNewCount = (value) => {
    const newCart = _.cloneDeep(cart);
    const newItem = newCart.items.filter((i) => _.isEqual(item, i))[0];
    if (newItem.count === 1 && value === -1) {
      newCart.items = newCart.items.filter((i) => !_.isEqual(item, i));
    } else {
      newItem.count += value;
    }
    setCart(newCart);
  };

  return (
    <div className="float-end">
      <InputGroup>
        <Button variant="outline-secondary" onClick={() => setNewCount(-1)}>
          -
        </Button>
        <Button variant="outline-secondary">{item.count}</Button>
        <Button variant="outline-secondary" onClick={() => setNewCount(1)}>
          +
        </Button>
      </InputGroup>
    </div>
  );
};

export default CartItemCount;
